import { createAsyncThunk } from '@reduxjs/toolkit';
import FilterTagPrintingList from '~/@core/domain/filters/tag/FilterTagPrintingList';
import * as tagPrinting from '~/services/producer/TagPrinting';
import { actions as TagPrintingActions } from '~/store/modules/tagPrinting';
import { alertRequest } from '../../alert/actions';
import { getErrorResponseMessage } from '~/utils/getErrorResponseMessage';

export const fetchTagsByProductView = createAsyncThunk(
  `tag-print/products`,
  async (params: FilterTagPrintingList, { dispatch, rejectWithValue }) => {
    try {
      const response = await tagPrinting.findManyByProducts(params);
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchTagsByCustomerView = createAsyncThunk(
  `tag-print/customers`,
  async (params: FilterTagPrintingList, { dispatch, rejectWithValue }) => {
    try {
      const response = await tagPrinting.findManyByProducts(params);
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchKlokTagsCustomerView = createAsyncThunk(
  `tag-print/klok/customer`,
  async (params: FilterTagPrintingList, { dispatch, rejectWithValue }) => {
    const formattedParams = {
      Data: {
        SiteId: params.SiteId,
        DeliveryDate: params.DeliveryDate,
        Type: params.Type,
        ProductCategoryId: params.ProductCategoryId,
        ProductGroupId: params.ProductGroupId,
        CustomerId: params.CustomerId,
        ExpeditionId: params.ExpeditionId,
        ProductId: params.ProductId,
        ProductRecipient: params.ProductRecipient,
        QualityId: params.QualityId,
        viewByCustomer: params.viewByCustomer
      },
      PageSize: params.pageSize,
      PageNumber: params.pageNumber
    };
    try {
      const response = await tagPrinting.findManyKlokTagsByCustomers(
        formattedParams
      );
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchKlokTagsProductView = createAsyncThunk(
  `tag-print/klok/products`,
  async (params: FilterTagPrintingList, { dispatch, rejectWithValue }) => {
    const formattedParams = {
      Data: {
        SiteId: params.SiteId,
        DeliveryDate: params.DeliveryDate,
        Type: params.Type,
        ProductCategoryId: params.ProductCategoryId,
        ProductGroupId: params.ProductGroupId,
        CustomerId: params.CustomerId,
        ExpeditionId: params.ExpeditionId,
        ProductId: params.ProductId,
        ProductRecipient: params.ProductRecipient,
        QualityId: params.QualityId,
        viewByCustomer: params.viewByCustomer
      },
      PageSize: params.pageSize,
      PageNumber: params.pageNumber
    };
    try {
      const response = await tagPrinting.findManyKlokTagsByProducts(
        formattedParams
      );
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export type fetchPrintedListParams = {
  Data: {
    siteId: number;
    customerId?: number;
    tagCode?: string;
    deliveryDate: string;
    type: string;
  };
  PageSize: number;
  PageNumber: number;
};

export const fetchPrintedListWithFilter = createAsyncThunk(
  `tag-print/printListManagement`,
  async (params: fetchPrintedListParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await tagPrinting.getPrintedListWithFilter(params);
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchPrintedList = createAsyncThunk(
  `tag-print/printListManagement`,
  async (
    params: { siteId: number; pageSize: number; pageNumber: number },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await tagPrinting.getPrintedList(params);
      return response;
    } catch (err: unknown) {
      const errorMessage = getErrorResponseMessage(
        err,
        'Erro ao buscar etiquetas!'
      );
      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateOrders = createAsyncThunk(
  `tag-print/updateOrders`,
  async (
    items: {
      saleTransactionId: number;
      origin: string;
      observation: string;
      obs1Id: string;
      obs2Id: string;
      packingId: number;
    }[],
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await tagPrinting.updateOrders(items);
      const { status, data } = response;

      if (status === 200) {
        dispatch(
          alertRequest(
            (data as any).message || 'Observações atualizadas com sucesso',
            'success'
          )
        );
        return (data as any).updateIds;
      }

      if (status === 207) {
        const errorIds = (data as any).errors.map(
          (error: { id: number }) => error.id
        );

        dispatch(TagPrintingActions.setErrors({ errorIds }));

        const errorMessages = (data as any).errors
          .map(
            (error: {
              id: number;
              message: string;
              productDescription: string;
              qualityCode: string;
            }) =>
              ` Produto: ${error.productDescription} (Qualidade: ${error.qualityCode}) - ${error.message}`
          )
          .join('\n');

        dispatch(
          alertRequest(`${(data as any).message}${errorMessages}`, 'warning')
        );
        return (data as any).successIds;
      }

      throw new Error((data as any).message || 'Erro ao atualizar pedidos!');
    } catch (err: any) {
      let errorMessage = 'Erro ao atualizar pedidos!';

      if (err.response && err.response.status === 422) {
        const { data } = err.response;
        const errorIds = data.errors.map((error: { id: number }) => error.id);

        dispatch(TagPrintingActions.setErrors({ errorIds }));

        const errorMessages = (data as any).errors
          .map(
            (error: {
              id: number;
              message: string;
              productDescription: string;
              qualityCode: string;
            }) =>
              ` Produto: ${error.productDescription} (Qualidade: ${error.qualityCode}) - ${error.message}`
          )
          .join('\n');

        errorMessage = `${(data as any).message}\n\n${errorMessages}`;
      } else {
        errorMessage = getErrorResponseMessage(err, errorMessage);
      }

      dispatch(alertRequest(errorMessage, 'error'));
      return rejectWithValue(errorMessage);
    }
  }
);
